import Box from "./Box";
import HeadingForLargePromo from "./HeadingForLargePromo";
import Image from "./Image";
import PropTypes from "prop-types";
import React from "react";

function LargeHeadingImageSectionAlt({
  heading,
  image,
  mobImage,
  bg,
  children,
}) {
  return (
    <Box bg={bg} pb={[60, null, 160, null]}>
      <Box position="relative" height={0} pb={[300, null, 490, null]}>
        <Image
          src={image.url}
          alt={image.title}
          imgHeight={image.height}
          imgWidth={image.width}
          height="100%"
          width={["calc(100% - 90px)", "calc(100% - 9.52vw)", null, null]}
          position="absolute"
          top={0}
          left={[15, "4.76vw", null, null]}
          objectFit="cover"
          objectPosition="50% 0%"
          display={["none", "initial", null, null]}
          bg="lightGrey"
        />
        <Image
          src={mobImage.url}
          alt={mobImage.title}
          imgHeight={mobImage.height}
          imgWidth={mobImage.width}
          height="100%"
          width={["calc(100% - 30px)", null, "calc(100% - 160px)", null]}
          position="absolute"
          top={0}
          left={[15, "4.76vw", null, null]}
          objectFit="cover"
          objectPosition="50% 0%"
          display={["initial", "none", null, null]}
          bg="lightGrey"
        />
        <Box
          position="absolute"
          height="100%"
          width="100%"
          top={0}
          left={0}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flex={1}
        >
          <Box maxWidth={[350, null, "calc(100% - 160px)", null]}>
            <HeadingForLargePromo>{heading}</HeadingForLargePromo>
          </Box>
        </Box>
      </Box>
      {children}
    </Box>
  );
}

export default LargeHeadingImageSectionAlt;

LargeHeadingImageSectionAlt.propTypes = {
  heading: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
  }).isRequired,
  mobImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
  }).isRequired,
  bg: PropTypes.string.isRequired,
};
